import { useSelector } from 'react-redux';
import { getCurrentDragItem, getDeepestHoveredNodePositionInfo } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { getAllGridLayoutTreesAsMap } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { layoutNodeTypes } from 'layout-dnd-utils/constants/dndAreaHoverPositionConstants';
import { getActiveBreakpointName } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { DRAG_TYPES } from 'layout-dnd-utils/constants/dnd';
import { DRAG_TYPES as CEUI_DRAG_TYPES } from 'ContentEditorUI/utils/DragAndDropConstants';
import styled from 'foundations-theming/utils';
// @ts-expect-error not typed yet
import { getGridNodeElement } from 'layout-dnd-utils/nodePositions/nodePositionGridLayoutTreeUtils';
import { createPortal } from 'react-dom';
import { NAMESPACE_CLASS } from 'ContentEditorUI/lib/inpage/Constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledGridCell = styled.div.withConfig({
  displayName: "PegboardDndCellsContainer__StyledGridCell"
})([".hs-private.hs-private.hs-private &{position:relative;opacity:0.5;border-color:", ";border-width:", ";border-style:dashed;block-size:100%;inline-size:100%;z-index:-1000;}"], ({
  theme
}) => theme.color['fill-info-default'], ({
  theme
}) => theme.borderWidth['100']);
function useGetCurrentPegboardContainerNode(gridLayoutId, containerId) {
  const deepestHoveredNodeInfo = useSelector(getDeepestHoveredNodePositionInfo);
  const gridLayoutTrees = useSelector(getAllGridLayoutTreesAsMap);
  const currentDragItem = useSelector(getCurrentDragItem);
  let containerNode = null;
  if (gridLayoutId && containerId) {
    const gridLayoutTree = gridLayoutTrees[gridLayoutId];
    if (gridLayoutTree && gridLayoutTree.hasContainer(containerId)) {
      containerNode = gridLayoutTree.findContainer(containerId);
      return containerNode && containerNode.isPegboardContainer() ? containerNode : null;
    }
  }
  if (!currentDragItem) {
    return null;
  }
  if (currentDragItem.dragType === DRAG_TYPES.EXISTING_ITEM) {
    const {
      originLayoutSectionId,
      parentId
    } = currentDragItem;
    const gridLayoutTree = gridLayoutTrees[originLayoutSectionId];
    if (gridLayoutTree && gridLayoutTree.hasContainer(parentId)) {
      containerNode = gridLayoutTree.findContainer(parentId);
    }
  } else if (currentDragItem.dragType === CEUI_DRAG_TYPES.ADD_MODULE && deepestHoveredNodeInfo && deepestHoveredNodeInfo.type === layoutNodeTypes.PEGBOARD) {
    const {
      gridLayoutId: hoveredGridLayoutId,
      id
    } = deepestHoveredNodeInfo;
    const gridLayoutTree = gridLayoutTrees[hoveredGridLayoutId];
    if (gridLayoutTree && gridLayoutTree.hasContainer(id)) {
      containerNode = gridLayoutTree.findContainer(id);
    }
  }
  return containerNode && containerNode.isPegboardContainer() ? containerNode : null;
}
export default function PegboardDndCellsContainer({
  gridLayoutId,
  containerId
}) {
  const activeBreakpointName = useSelector(getActiveBreakpointName);
  const currentPegboardContainerNode = useGetCurrentPegboardContainerNode(gridLayoutId, containerId);
  if (!currentPegboardContainerNode) {
    return null;
  }
  const pegboardElement = getGridNodeElement(currentPegboardContainerNode);
  const pegboardLayout = currentPegboardContainerNode.getContainerLayout(activeBreakpointName);
  if (!pegboardElement || !pegboardLayout) {
    return null;
  }
  return /*#__PURE__*/createPortal( /*#__PURE__*/_jsx(_Fragment, {
    children: Array.from({
      length: pegboardLayout.rows.length
    }).map((_, row) => {
      return Array.from({
        length: pegboardLayout.columns.length
      }).map((__, col) => {
        const gridRow = row + 1;
        const gridColumn = col + 1;
        return /*#__PURE__*/_jsx("div", {
          className: NAMESPACE_CLASS,
          "data-hs-pegboard-cell-id": `cell-${gridRow}-${gridColumn}`,
          style: {
            gridRow: `${gridRow} / span 1`,
            gridColumn: `${gridColumn} / span 1`
          },
          children: /*#__PURE__*/_jsx(StyledGridCell, {})
        }, `${gridRow}-${gridColumn}`);
      });
    })
  }), pegboardElement);
}